import barDefaultConfig, { getTooltip, getLabel } from '../../theme/bar';
import { getLegendStyle } from '../../theme/common/legend';
import setBarWidth from './setBarWidth';
import { isType } from '../../utils/util';
import merge from 'lodash.merge';
import cloneDeep from 'lodash.clonedeep';

var getBarTooltip = function getBarTooltip(config) {
  return getTooltip();
};

var getBarLabel = function getBarLabel(config) {
  return getLabel();
};

var getBarLegend = function getBarLegend(config) {
  return getLegendStyle();
};

var getBarYAxis = function getBarYAxis(config) {
  return {
    type: 'value'
  };
};

var getBarSeries = function getBarSeries(config, series) {
  setBarWidth(series);
  return series;
};

export default function (config) {
  if (config === void 0) {
    config = {};
  }

  return function (options) {
    var tooltip = getBarTooltip(config);
    var yAxis = getBarYAxis(config);
    var label = getBarLabel(config);
    var legend = getBarLegend(config);
    var series = getBarSeries(config, cloneDeep(options.series));
    return merge({
      tooltip: tooltip,
      label: label,
      legend: legend,
      yAxis: yAxis,
      series: series
    }, options);
  };
}